import { DEFAULT_PHONE_MASK } from '@gem/utils';

import { ICountry } from 'APP/types/countryCodes';

export const DEFAULT_ACCOUNT_COUNTRY: ICountry = {
  countryCode: '',
  countryName: '',
  flag: '',
  phonePrefix: '',
  phoneTemplate: DEFAULT_PHONE_MASK,
};

export const COUNTRIES: ICountry[] = [
  {
    countryCode: 'AD',
    countryName: 'Андорра',
    phonePrefix: '+376',
    phoneTemplate: '+XXX XXX XXX',
    flag: '🇦🇩',
  },
  {
    countryCode: 'AE',
    countryName: 'ОАЭ',
    phonePrefix: '+971',
    phoneTemplate: '+XXX XX XXX XXXX',
    flag: '🇦🇪',
  },
  {
    countryCode: 'AF',
    countryName: 'Афганистан',
    phonePrefix: '+93',
    phoneTemplate: '+XX XX XXX XXXX',
    flag: '🇦🇫',
  },
  {
    countryCode: 'AG',
    countryName: 'Антигуа и Барбуда',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇦🇬',
  },
  {
    countryCode: 'AI',
    countryName: 'Ангилья',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇦🇮',
  },
  {
    countryCode: 'AL',
    countryName: 'Албания',
    phonePrefix: '+355',
    phoneTemplate: '+XXX XX XXX XXXX',
    flag: '🇦🇱',
  },
  {
    countryCode: 'AM',
    countryName: 'Армения',
    phonePrefix: '+374',
    phoneTemplate: '+XXX XX XXXXXX',
    flag: '🇦🇲',
  },
  {
    countryCode: 'AO',
    countryName: 'Ангола',
    phonePrefix: '+244',
    phoneTemplate: '+XXX XXX XXX XXX',
    flag: '🇦🇴',
  },
  {
    countryCode: 'AR',
    countryName: 'Аргентина',
    phonePrefix: '+54',
    phoneTemplate: '+XX X XX XXXX-XXXX',
    flag: '🇦🇷',
  },
  {
    countryCode: 'AS',
    countryName: 'Американское Самоа',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇦🇸',
  },
  {
    countryCode: 'AT',
    countryName: 'Австрия',
    phonePrefix: '+43',
    phoneTemplate: '+XX XXX XXXXXX',
    flag: '🇦🇹',
  },
  {
    countryCode: 'AU',
    countryName: 'Австралия',
    phonePrefix: '+61',
    phoneTemplate: '+XX XXX XXX XXX',
    flag: '🇦🇺',
  },
  {
    countryCode: 'AW',
    countryName: 'Аруба',
    phonePrefix: '+297',
    phoneTemplate: '+XXX XXX XXXX',
    flag: '🇦🇼',
  },
  {
    countryCode: 'AX',
    countryName: 'Аландские о-ва',
    phonePrefix: '+358',
    phoneTemplate: '+XXX XX XXXXXXX',
    flag: '🇦🇽',
  },
  {
    countryCode: 'AZ',
    countryName: 'Азербайджан',
    phonePrefix: '+994',
    phoneTemplate: '+XXX XX XXX XX XX',
    flag: '🇦🇿',
  },
  {
    countryCode: 'BA',
    countryName: 'Босния и Герцеговина',
    phonePrefix: '+387',
    phoneTemplate: '+XXX XX XXX XXX',
    flag: '🇧🇦',
  },
  {
    countryCode: 'BB',
    countryName: 'Барбадос',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇧🇧',
  },
  {
    countryCode: 'BD',
    countryName: 'Бангладеш',
    phonePrefix: '+880',
    phoneTemplate: '+XXX XXXX-XXXXXX',
    flag: '🇧🇩',
  },
  {
    countryCode: 'BE',
    countryName: 'Бельгия',
    phonePrefix: '+32',
    phoneTemplate: '+XX XXX XX XX XX',
    flag: '🇧🇪',
  },
  {
    countryCode: 'BF',
    countryName: 'Буркина-Фасо',
    phonePrefix: '+226',
    phoneTemplate: '+XXX XX XX XX XX',
    flag: '🇧🇫',
  },
  {
    countryCode: 'BG',
    countryName: 'Болгария',
    phonePrefix: '+359',
    phoneTemplate: '+XXX XX XXX XXX',
    flag: '🇧🇬',
  },
  {
    countryCode: 'BH',
    countryName: 'Бахрейн',
    phonePrefix: '+973',
    phoneTemplate: '+XXX XXXX XXXX',
    flag: '🇧🇭',
  },
  {
    countryCode: 'BI',
    countryName: 'Бурунди',
    phonePrefix: '+257',
    phoneTemplate: '+XXX XX XX XX XX',
    flag: '🇧🇮',
  },
  {
    countryCode: 'BJ',
    countryName: 'Бенин',
    phonePrefix: '+229',
    phoneTemplate: '+XXX XX XX XX XX',
    flag: '🇧🇯',
  },
  {
    countryCode: 'BL',
    countryName: 'Сен-Бартелеми',
    phonePrefix: '+590',
    phoneTemplate: '+XXX XXX XX XX XX',
    flag: '🇧🇱',
  },
  {
    countryCode: 'BM',
    countryName: 'Бермудские о-ва',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇧🇲',
  },
  {
    countryCode: 'BN',
    countryName: 'Бруней',
    phonePrefix: '+673',
    phoneTemplate: '+XXX XXX XXXX',
    flag: '🇧🇳',
  },
  {
    countryCode: 'BO',
    countryName: 'Боливия',
    phonePrefix: '+591',
    phoneTemplate: '+XXX XXXXXXXX',
    flag: '🇧🇴',
  },
  {
    countryCode: 'BQ',
    countryName: 'Бонэйр, Синт-Эстатиус и Саба',
    phonePrefix: '+599',
    phoneTemplate: '+XXX XXX XXXX',
    flag: '🇧🇶',
  },
  {
    countryCode: 'BR',
    countryName: 'Бразилия',
    phonePrefix: '+55',
    phoneTemplate: '+XX XX XXXXX-XXXX',
    flag: '🇧🇷',
  },
  {
    countryCode: 'BS',
    countryName: 'Багамы',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇧🇸',
  },
  {
    countryCode: 'BT',
    countryName: 'Бутан',
    phonePrefix: '+975',
    phoneTemplate: '+XXX XX XX XX XX',
    flag: '🇧🇹',
  },
  {
    countryCode: 'BW',
    countryName: 'Ботсвана',
    phonePrefix: '+267',
    phoneTemplate: '+XXX XX XXX XXX',
    flag: '🇧🇼',
  },
  {
    countryCode: 'BY',
    countryName: 'Беларусь',
    phonePrefix: '+375',
    phoneTemplate: '+XXX XX XXX-XX-XX',
    flag: '🇧🇾',
  },
  {
    countryCode: 'BZ',
    countryName: 'Белиз',
    phonePrefix: '+501',
    phoneTemplate: '+XXX XXX-XXXX',
    flag: '🇧🇿',
  },
  {
    countryCode: 'CA',
    countryName: 'Канада',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇨🇦',
  },
  {
    countryCode: 'CC',
    countryName: 'Кокосовые о-ва',
    phonePrefix: '+61',
    phoneTemplate: '+XX XXX XXX XXX',
    flag: '🇨🇨',
  },
  {
    countryCode: 'CD',
    countryName: 'Конго - Киншаса',
    phonePrefix: '+243',
    phoneTemplate: '+XXX XXX XXX XXX',
    flag: '🇨🇩',
  },
  {
    countryCode: 'CF',
    countryName: 'Центрально-Африканская Республика',
    phonePrefix: '+236',
    phoneTemplate: '+XXX XX XX XX XX',
    flag: '🇨🇫',
  },
  {
    countryCode: 'CG',
    countryName: 'Конго - Браззавиль',
    phonePrefix: '+242',
    phoneTemplate: '+XXX XX XXX XXXX',
    flag: '🇨🇬',
  },
  {
    countryCode: 'CH',
    countryName: 'Швейцария',
    phonePrefix: '+41',
    phoneTemplate: '+XX XX XXX XX XX',
    flag: '🇨🇭',
  },
  {
    countryCode: 'CI',
    countryName: 'Кот-д’Ивуар',
    phonePrefix: '+225',
    phoneTemplate: '+XXX XX XX XX XXXX',
    flag: '🇨🇮',
  },
  {
    countryCode: 'CK',
    countryName: 'о-ва Кука',
    phonePrefix: '+682',
    phoneTemplate: '+XXX XX XXX',
    flag: '🇨🇰',
  },
  {
    countryCode: 'CL',
    countryName: 'Чили',
    phonePrefix: '+56',
    phoneTemplate: '+XX X XXXX XXXX',
    flag: '🇨🇱',
  },
  {
    countryCode: 'CM',
    countryName: 'Камерун',
    phonePrefix: '+237',
    phoneTemplate: '+XXX X XX XX XX XX',
    flag: '🇨🇲',
  },
  {
    countryCode: 'CN',
    countryName: 'Китай',
    phonePrefix: '+86',
    phoneTemplate: '+XX XXX XXXX XXXX',
    flag: '🇨🇳',
  },
  {
    countryCode: 'CO',
    countryName: 'Колумбия',
    phonePrefix: '+57',
    phoneTemplate: '+XX XXX XXXXXXX',
    flag: '🇨🇴',
  },
  {
    countryCode: 'CR',
    countryName: 'Коста-Рика',
    phonePrefix: '+506',
    phoneTemplate: '+XXX XXXX XXXX',
    flag: '🇨🇷',
  },
  {
    countryCode: 'CU',
    countryName: 'Куба',
    phonePrefix: '+53',
    phoneTemplate: '+XX X XXXXXXX',
    flag: '🇨🇺',
  },
  {
    countryCode: 'CV',
    countryName: 'Кабо-Верде',
    phonePrefix: '+238',
    phoneTemplate: '+XXX XXX XX XX',
    flag: '🇨🇻',
  },
  {
    countryCode: 'CW',
    countryName: 'Кюрасао',
    phonePrefix: '+599',
    phoneTemplate: '+XXX X XXX XXXX',
    flag: '🇨🇼',
  },
  {
    countryCode: 'CX',
    countryName: 'о-в Рождества',
    phonePrefix: '+61',
    phoneTemplate: '+XX XXX XXX XXX',
    flag: '🇨🇽',
  },
  {
    countryCode: 'CY',
    countryName: 'Кипр',
    phonePrefix: '+357',
    phoneTemplate: '+XXX XX XXXXXX',
    flag: '🇨🇾',
  },
  {
    countryCode: 'CZ',
    countryName: 'Чехия',
    phonePrefix: '+420',
    phoneTemplate: '+XXX XXX XXX XXX',
    flag: '🇨🇿',
  },
  {
    countryCode: 'DE',
    countryName: 'Германия',
    phonePrefix: '+49',
    phoneTemplate: '+XX XXXX XXXXXXX',
    flag: '🇩🇪',
  },
  {
    countryCode: 'DJ',
    countryName: 'Джибути',
    phonePrefix: '+253',
    phoneTemplate: '+XXX XX XX XX XX',
    flag: '🇩🇯',
  },
  {
    countryCode: 'DK',
    countryName: 'Дания',
    phonePrefix: '+45',
    phoneTemplate: '+XX XX XX XX XX',
    flag: '🇩🇰',
  },
  {
    countryCode: 'DM',
    countryName: 'Доминика',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇩🇲',
  },
  {
    countryCode: 'DO',
    countryName: 'Доминиканская Республика',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇩🇴',
  },
  {
    countryCode: 'DZ',
    countryName: 'Алжир',
    phonePrefix: '+213',
    phoneTemplate: '+XXX XXX XX XX XX',
    flag: '🇩🇿',
  },
  {
    countryCode: 'EC',
    countryName: 'Эквадор',
    phonePrefix: '+593',
    phoneTemplate: '+XXX XX XXX XXXX',
    flag: '🇪🇨',
  },
  {
    countryCode: 'EE',
    countryName: 'Эстония',
    phonePrefix: '+372',
    phoneTemplate: '+XXX XXXX XXXX',
    flag: '🇪🇪',
  },
  {
    countryCode: 'EG',
    countryName: 'Египет',
    phonePrefix: '+20',
    phoneTemplate: '+XX XX XXXXXXXX',
    flag: '🇪🇬',
  },
  {
    countryCode: 'EH',
    countryName: 'Западная Сахара',
    phonePrefix: '+212',
    phoneTemplate: '+XXX XXX-XXXXXX',
    flag: '🇪🇭',
  },
  {
    countryCode: 'ER',
    countryName: 'Эритрея',
    phonePrefix: '+291',
    phoneTemplate: '+XXX X XXX XXX',
    flag: '🇪🇷',
  },
  {
    countryCode: 'ES',
    countryName: 'Испания',
    phonePrefix: '+34',
    phoneTemplate: '+XX XXX XX XX XX',
    flag: '🇪🇸',
  },
  {
    countryCode: 'ET',
    countryName: 'Эфиопия',
    phonePrefix: '+251',
    phoneTemplate: '+XXX XX XXX XXXX',
    flag: '🇪🇹',
  },
  {
    countryCode: 'FI',
    countryName: 'Финляндия',
    phonePrefix: '+358',
    phoneTemplate: '+XXX XX XXXXXXX',
    flag: '🇫🇮',
  },
  {
    countryCode: 'FJ',
    countryName: 'Фиджи',
    phonePrefix: '+679',
    phoneTemplate: '+XXX XXX XXXX',
    flag: '🇫🇯',
  },
  {
    countryCode: 'FK',
    countryName: 'Фолклендские о-ва',
    phonePrefix: '+500',
    phoneTemplate: '+XXX XXXXX',
    flag: '🇫🇰',
  },
  {
    countryCode: 'FM',
    countryName: 'Федеративные Штаты Микронезии',
    phonePrefix: '+691',
    phoneTemplate: '+XXX XXX XXXX',
    flag: '🇫🇲',
  },
  {
    countryCode: 'FO',
    countryName: 'Фарерские о-ва',
    phonePrefix: '+298',
    phoneTemplate: '+XXX XXXXXX',
    flag: '🇫🇴',
  },
  {
    countryCode: 'FR',
    countryName: 'Франция',
    phonePrefix: '+33',
    phoneTemplate: '+XX X XX XX XX XX',
    flag: '🇫🇷',
  },
  {
    countryCode: 'GA',
    countryName: 'Габон',
    phonePrefix: '+241',
    phoneTemplate: '+XXX XX XX XX XX',
    flag: '🇬🇦',
  },
  {
    countryCode: 'GB',
    countryName: 'Великобритания',
    phonePrefix: '+44',
    phoneTemplate: '+XX XXXX XXXXXX',
    flag: '🇬🇧',
  },
  {
    countryCode: 'GD',
    countryName: 'Гренада',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇬🇩',
  },
  {
    countryCode: 'GE',
    countryName: 'Грузия',
    phonePrefix: '+995',
    phoneTemplate: '+XXX XXX XX XX XX',
    flag: '🇬🇪',
  },
  {
    countryCode: 'GF',
    countryName: 'Французская Гвиана',
    phonePrefix: '+594',
    phoneTemplate: '+XXX XXX XX XX XX',
    flag: '🇬🇫',
  },
  {
    countryCode: 'GG',
    countryName: 'Гернси',
    phonePrefix: '+44',
    phoneTemplate: '+XX XXXX XXXXXX',
    flag: '🇬🇬',
  },
  {
    countryCode: 'GH',
    countryName: 'Гана',
    phonePrefix: '+233',
    phoneTemplate: '+XXX XX XXX XXXX',
    flag: '🇬🇭',
  },
  {
    countryCode: 'GI',
    countryName: 'Гибралтар',
    phonePrefix: '+350',
    phoneTemplate: '+XXX XXXXXXXX',
    flag: '🇬🇮',
  },
  {
    countryCode: 'GL',
    countryName: 'Гренландия',
    phonePrefix: '+299',
    phoneTemplate: '+XXX XX XX XX',
    flag: '🇬🇱',
  },
  {
    countryCode: 'GM',
    countryName: 'Гамбия',
    phonePrefix: '+220',
    phoneTemplate: '+XXX XXX XXXX',
    flag: '🇬🇲',
  },
  {
    countryCode: 'GN',
    countryName: 'Гвинея',
    phonePrefix: '+224',
    phoneTemplate: '+XXX XXX XX XX XX',
    flag: '🇬🇳',
  },
  {
    countryCode: 'GP',
    countryName: 'Гваделупа',
    phonePrefix: '+590',
    phoneTemplate: '+XXX XXX XX XX XX',
    flag: '🇬🇵',
  },
  {
    countryCode: 'GQ',
    countryName: 'Экваториальная Гвинея',
    phonePrefix: '+240',
    phoneTemplate: '+XXX XXX XXX XXX',
    flag: '🇬🇶',
  },
  {
    countryCode: 'GR',
    countryName: 'Греция',
    phonePrefix: '+30',
    phoneTemplate: '+XX XXX XXX XXXX',
    flag: '🇬🇷',
  },
  {
    countryCode: 'GT',
    countryName: 'Гватемала',
    phonePrefix: '+502',
    phoneTemplate: '+XXX XXXX XXXX',
    flag: '🇬🇹',
  },
  {
    countryCode: 'GU',
    countryName: 'Гуам',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇬🇺',
  },
  {
    countryCode: 'GW',
    countryName: 'Гвинея-Бисау',
    phonePrefix: '+245',
    phoneTemplate: '+XXX XXX XXX XXX',
    flag: '🇬🇼',
  },
  {
    countryCode: 'GY',
    countryName: 'Гайана',
    phonePrefix: '+592',
    phoneTemplate: '+XXX XXX XXXX',
    flag: '🇬🇾',
  },
  {
    countryCode: 'HK',
    countryName: 'Гонконг (САР)',
    phonePrefix: '+852',
    phoneTemplate: '+XXX XXXX XXXX',
    flag: '🇭🇰',
  },
  {
    countryCode: 'HN',
    countryName: 'Гондурас',
    phonePrefix: '+504',
    phoneTemplate: '+XXX XXXX-XXXX',
    flag: '🇭🇳',
  },
  {
    countryCode: 'HR',
    countryName: 'Хорватия',
    phonePrefix: '+385',
    phoneTemplate: '+XXX XX XXX XXXX',
    flag: '🇭🇷',
  },
  {
    countryCode: 'HT',
    countryName: 'Гаити',
    phonePrefix: '+509',
    phoneTemplate: '+XXX XX XX XXXX',
    flag: '🇭🇹',
  },
  {
    countryCode: 'HU',
    countryName: 'Венгрия',
    phonePrefix: '+36',
    phoneTemplate: '+XX XX XXX XXXX',
    flag: '🇭🇺',
  },
  {
    countryCode: 'ID',
    countryName: 'Индонезия',
    phonePrefix: '+62',
    phoneTemplate: '+XX XXX-XXX-XXX',
    flag: '🇮🇩',
  },
  {
    countryCode: 'IE',
    countryName: 'Ирландия',
    phonePrefix: '+353',
    phoneTemplate: '+XXX XX XXX XXXX',
    flag: '🇮🇪',
  },
  {
    countryCode: 'IL',
    countryName: 'Израиль',
    phonePrefix: '+972',
    phoneTemplate: '+XXX XX-XXX-XXXX',
    flag: '🇮🇱',
  },
  {
    countryCode: 'IM',
    countryName: 'о-в Мэн',
    phonePrefix: '+44',
    phoneTemplate: '+XX XXXX XXXXXX',
    flag: '🇮🇲',
  },
  {
    countryCode: 'IN',
    countryName: 'Индия',
    phonePrefix: '+91',
    phoneTemplate: '+XX XXXXX XXXXX',
    flag: '🇮🇳',
  },
  {
    countryCode: 'IO',
    countryName: 'Британская территория в Индийском океане',
    phonePrefix: '+246',
    phoneTemplate: '+XXX XXX XXXX',
    flag: '🇮🇴',
  },
  {
    countryCode: 'IQ',
    countryName: 'Ирак',
    phonePrefix: '+964',
    phoneTemplate: '+XXX XXX XXX XXXX',
    flag: '🇮🇶',
  },
  {
    countryCode: 'IR',
    countryName: 'Иран',
    phonePrefix: '+98',
    phoneTemplate: '+XX XXX XXX XXXX',
    flag: '🇮🇷',
  },
  {
    countryCode: 'IS',
    countryName: 'Исландия',
    phonePrefix: '+354',
    phoneTemplate: '+XXX XXX XXXX',
    flag: '🇮🇸',
  },
  {
    countryCode: 'IT',
    countryName: 'Италия',
    phonePrefix: '+39',
    phoneTemplate: '+XX XXX XXX XXXX',
    flag: '🇮🇹',
  },
  {
    countryCode: 'JE',
    countryName: 'Джерси',
    phonePrefix: '+44',
    phoneTemplate: '+XX XXXX XXXXXX',
    flag: '🇯🇪',
  },
  {
    countryCode: 'JM',
    countryName: 'Ямайка',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇯🇲',
  },
  {
    countryCode: 'JO',
    countryName: 'Иордания',
    phonePrefix: '+962',
    phoneTemplate: '+XXX X XXXX XXXX',
    flag: '🇯🇴',
  },
  {
    countryCode: 'JP',
    countryName: 'Япония',
    phonePrefix: '+81',
    phoneTemplate: '+XX XX-XXXX-XXXX',
    flag: '🇯🇵',
  },
  {
    countryCode: 'KE',
    countryName: 'Кения',
    phonePrefix: '+254',
    phoneTemplate: '+XXX XXX XXXXXX',
    flag: '🇰🇪',
  },
  {
    countryCode: 'KG',
    countryName: 'Киргизия',
    phonePrefix: '+996',
    phoneTemplate: '+XXX XXX XXX XXX',
    flag: '🇰🇬',
  },
  {
    countryCode: 'KH',
    countryName: 'Камбоджа',
    phonePrefix: '+855',
    phoneTemplate: '+XXX XX XXX XXX',
    flag: '🇰🇭',
  },
  {
    countryCode: 'KI',
    countryName: 'Кирибати',
    phonePrefix: '+686',
    phoneTemplate: '+XXX XXXXXXXX',
    flag: '🇰🇮',
  },
  {
    countryCode: 'KM',
    countryName: 'Коморы',
    phonePrefix: '+269',
    phoneTemplate: '+XXX XXX XX XX',
    flag: '🇰🇲',
  },
  {
    countryCode: 'KN',
    countryName: 'Сент-Китс и Невис',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇰🇳',
  },
  {
    countryCode: 'KP',
    countryName: 'КНДР',
    phonePrefix: '+850',
    phoneTemplate: '+XXX XXX XXX XXXX',
    flag: '🇰🇵',
  },
  {
    countryCode: 'KR',
    countryName: 'Республика Корея',
    phonePrefix: '+82',
    phoneTemplate: '+XX XX-XXXX-XXXX',
    flag: '🇰🇷',
  },
  {
    countryCode: 'KW',
    countryName: 'Кувейт',
    phonePrefix: '+965',
    phoneTemplate: '+XXX XXX XXXXX',
    flag: '🇰🇼',
  },
  {
    countryCode: 'KY',
    countryName: 'о-ва Кайман',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇰🇾',
  },
  {
    countryCode: 'KZ',
    countryName: 'Казахстан',
    phonePrefix: '+7',
    phoneTemplate: '+X XXX XXX XXXX',
    flag: '🇰🇿',
  },
  {
    countryCode: 'LA',
    countryName: 'Лаос',
    phonePrefix: '+856',
    phoneTemplate: '+XXX XX XX XXX XXX',
    flag: '🇱🇦',
  },
  {
    countryCode: 'LB',
    countryName: 'Ливан',
    phonePrefix: '+961',
    phoneTemplate: '+XXX XX XXX XXX',
    flag: '🇱🇧',
  },
  {
    countryCode: 'LC',
    countryName: 'Сент-Люсия',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇱🇨',
  },
  {
    countryCode: 'LI',
    countryName: 'Лихтенштейн',
    phonePrefix: '+423',
    phoneTemplate: '+XXX XXX XXX XXX',
    flag: '🇱🇮',
  },
  {
    countryCode: 'LK',
    countryName: 'Шри-Ланка',
    phonePrefix: '+94',
    phoneTemplate: '+XX XX XXX XXXX',
    flag: '🇱🇰',
  },
  {
    countryCode: 'LR',
    countryName: 'Либерия',
    phonePrefix: '+231',
    phoneTemplate: '+XXX XX XXX XXXX',
    flag: '🇱🇷',
  },
  {
    countryCode: 'LS',
    countryName: 'Лесото',
    phonePrefix: '+266',
    phoneTemplate: '+XXX XXXX XXXX',
    flag: '🇱🇸',
  },
  {
    countryCode: 'LT',
    countryName: 'Литва',
    phonePrefix: '+370',
    phoneTemplate: '+XXX XXX XXXXX',
    flag: '🇱🇹',
  },
  {
    countryCode: 'LU',
    countryName: 'Люксембург',
    phonePrefix: '+352',
    phoneTemplate: '+XXX XXX XXX XXX',
    flag: '🇱🇺',
  },
  {
    countryCode: 'LV',
    countryName: 'Латвия',
    phonePrefix: '+371',
    phoneTemplate: '+XXX XX XXX XXX',
    flag: '🇱🇻',
  },
  {
    countryCode: 'LY',
    countryName: 'Ливия',
    phonePrefix: '+218',
    phoneTemplate: '+XXX XX-XXXXXXX',
    flag: '🇱🇾',
  },
  {
    countryCode: 'MA',
    countryName: 'Марокко',
    phonePrefix: '+212',
    phoneTemplate: '+XXX XXX-XXXXXX',
    flag: '🇲🇦',
  },
  {
    countryCode: 'MC',
    countryName: 'Монако',
    phonePrefix: '+377',
    phoneTemplate: '+XXX X XX XX XX XX',
    flag: '🇲🇨',
  },
  {
    countryCode: 'MD',
    countryName: 'Молдова',
    phonePrefix: '+373',
    phoneTemplate: '+XXX XXX XX XXX',
    flag: '🇲🇩',
  },
  {
    countryCode: 'ME',
    countryName: 'Черногория',
    phonePrefix: '+382',
    phoneTemplate: '+XXX XX XXX XXX',
    flag: '🇲🇪',
  },
  {
    countryCode: 'MF',
    countryName: 'Сен-Мартен',
    phonePrefix: '+590',
    phoneTemplate: '+XXX XXX XX XX XX',
    flag: '🇲🇫',
  },
  {
    countryCode: 'MG',
    countryName: 'Мадагаскар',
    phonePrefix: '+261',
    phoneTemplate: '+XXX XX XX XXX XX',
    flag: '🇲🇬',
  },
  {
    countryCode: 'MH',
    countryName: 'Маршалловы о-ва',
    phonePrefix: '+692',
    phoneTemplate: '+XXX XXX-XXXX',
    flag: '🇲🇭',
  },
  {
    countryCode: 'MK',
    countryName: 'Северная Македония',
    phonePrefix: '+389',
    phoneTemplate: '+XXX XX XXX XXX',
    flag: '🇲🇰',
  },
  {
    countryCode: 'ML',
    countryName: 'Мали',
    phonePrefix: '+223',
    phoneTemplate: '+XXX XX XX XX XX',
    flag: '🇲🇱',
  },
  {
    countryCode: 'MM',
    countryName: 'Мьянма (Бирма)',
    phonePrefix: '+95',
    phoneTemplate: '+XX X XXX XXXX',
    flag: '🇲🇲',
  },
  {
    countryCode: 'MN',
    countryName: 'Монголия',
    phonePrefix: '+976',
    phoneTemplate: '+XXX XXXX XXXX',
    flag: '🇲🇳',
  },
  {
    countryCode: 'MO',
    countryName: 'Макао (САР)',
    phonePrefix: '+853',
    phoneTemplate: '+XXX XXXX XXXX',
    flag: '🇲🇴',
  },
  {
    countryCode: 'MP',
    countryName: 'Северные Марианские о-ва',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇲🇵',
  },
  {
    countryCode: 'MQ',
    countryName: 'Мартиника',
    phonePrefix: '+596',
    phoneTemplate: '+XXX XXX XX XX XX',
    flag: '🇲🇶',
  },
  {
    countryCode: 'MR',
    countryName: 'Мавритания',
    phonePrefix: '+222',
    phoneTemplate: '+XXX XX XX XX XX',
    flag: '🇲🇷',
  },
  {
    countryCode: 'MS',
    countryName: 'Монтсеррат',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇲🇸',
  },
  {
    countryCode: 'MT',
    countryName: 'Мальта',
    phonePrefix: '+356',
    phoneTemplate: '+XXX XXXX XXXX',
    flag: '🇲🇹',
  },
  {
    countryCode: 'MU',
    countryName: 'Маврикий',
    phonePrefix: '+230',
    phoneTemplate: '+XXX XXXX XXXX',
    flag: '🇲🇺',
  },
  {
    countryCode: 'MV',
    countryName: 'Мальдивы',
    phonePrefix: '+960',
    phoneTemplate: '+XXX XXX-XXXX',
    flag: '🇲🇻',
  },
  {
    countryCode: 'MW',
    countryName: 'Малави',
    phonePrefix: '+265',
    phoneTemplate: '+XXX XXX XX XX XX',
    flag: '🇲🇼',
  },
  {
    countryCode: 'MX',
    countryName: 'Мексика',
    phonePrefix: '+52',
    phoneTemplate: '+XX XXX XXX XXXX',
    flag: '🇲🇽',
  },
  {
    countryCode: 'MY',
    countryName: 'Малайзия',
    phonePrefix: '+60',
    phoneTemplate: '+XX XX-XXX XXXX',
    flag: '🇲🇾',
  },
  {
    countryCode: 'MZ',
    countryName: 'Мозамбик',
    phonePrefix: '+258',
    phoneTemplate: '+XXX XX XXX XXXX',
    flag: '🇲🇿',
  },
  {
    countryCode: 'NA',
    countryName: 'Намибия',
    phonePrefix: '+264',
    phoneTemplate: '+XXX XX XXX XXXX',
    flag: '🇳🇦',
  },
  {
    countryCode: 'NC',
    countryName: 'Новая Каледония',
    phonePrefix: '+687',
    phoneTemplate: '+XXX XX.XX.XX',
    flag: '🇳🇨',
  },
  {
    countryCode: 'NE',
    countryName: 'Нигер',
    phonePrefix: '+227',
    phoneTemplate: '+XXX XX XX XX XX',
    flag: '🇳🇪',
  },
  {
    countryCode: 'NF',
    countryName: 'о-в Норфолк',
    phonePrefix: '+672',
    phoneTemplate: '+XXX X XXXXX',
    flag: '🇳🇫',
  },
  {
    countryCode: 'NG',
    countryName: 'Нигерия',
    phonePrefix: '+234',
    phoneTemplate: '+XXX XXX XXX XXXX',
    flag: '🇳🇬',
  },
  {
    countryCode: 'NI',
    countryName: 'Никарагуа',
    phonePrefix: '+505',
    phoneTemplate: '+XXX XXXX XXXX',
    flag: '🇳🇮',
  },
  {
    countryCode: 'NL',
    countryName: 'Нидерланды',
    phonePrefix: '+31',
    phoneTemplate: '+XX X XXXXXXXX',
    flag: '🇳🇱',
  },
  {
    countryCode: 'NO',
    countryName: 'Норвегия',
    phonePrefix: '+47',
    phoneTemplate: '+XX XX XX XX XX',
    flag: '🇳🇴',
  },
  {
    countryCode: 'NP',
    countryName: 'Непал',
    phonePrefix: '+977',
    phoneTemplate: '+XXX XXX-XXXXXXX',
    flag: '🇳🇵',
  },
  {
    countryCode: 'NR',
    countryName: 'Науру',
    phonePrefix: '+674',
    phoneTemplate: '+XXX XXX XXXX',
    flag: '🇳🇷',
  },
  {
    countryCode: 'NU',
    countryName: 'Ниуэ',
    phonePrefix: '+683',
    phoneTemplate: '+XXX XXX XXXX',
    flag: '🇳🇺',
  },
  {
    countryCode: 'NZ',
    countryName: 'Новая Зеландия',
    phonePrefix: '+64',
    phoneTemplate: '+XX XX XXX XXXX',
    flag: '🇳🇿',
  },
  {
    countryCode: 'OM',
    countryName: 'Оман',
    phonePrefix: '+968',
    phoneTemplate: '+XXX XXXX XXXX',
    flag: '🇴🇲',
  },
  {
    countryCode: 'PA',
    countryName: 'Панама',
    phonePrefix: '+507',
    phoneTemplate: '+XXX XXXX-XXXX',
    flag: '🇵🇦',
  },
  {
    countryCode: 'PE',
    countryName: 'Перу',
    phonePrefix: '+51',
    phoneTemplate: '+XX XXX XXX XXX',
    flag: '🇵🇪',
  },
  {
    countryCode: 'PF',
    countryName: 'Французская Полинезия',
    phonePrefix: '+689',
    phoneTemplate: '+XXX XX XX XX XX',
    flag: '🇵🇫',
  },
  {
    countryCode: 'PG',
    countryName: 'Папуа — Новая Гвинея',
    phonePrefix: '+675',
    phoneTemplate: '+XXX XXXX XXXX',
    flag: '🇵🇬',
  },
  {
    countryCode: 'PH',
    countryName: 'Филиппины',
    phonePrefix: '+63',
    phoneTemplate: '+XX XXX XXX XXXX',
    flag: '🇵🇭',
  },
  {
    countryCode: 'PK',
    countryName: 'Пакистан',
    phonePrefix: '+92',
    phoneTemplate: '+XX XXX XXXXXXX',
    flag: '🇵🇰',
  },
  {
    countryCode: 'PL',
    countryName: 'Польша',
    phonePrefix: '+48',
    phoneTemplate: '+XX XXX XXX XXX',
    flag: '🇵🇱',
  },
  {
    countryCode: 'PM',
    countryName: 'Сен-Пьер и Микелон',
    phonePrefix: '+508',
    phoneTemplate: '+XXX XX XX XX',
    flag: '🇵🇲',
  },
  {
    countryCode: 'PR',
    countryName: 'Пуэрто-Рико',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇵🇷',
  },
  {
    countryCode: 'PS',
    countryName: 'Палестинские территории',
    phonePrefix: '+970',
    phoneTemplate: '+XXX XXX XXX XXX',
    flag: '🇵🇸',
  },
  {
    countryCode: 'PT',
    countryName: 'Португалия',
    phonePrefix: '+351',
    phoneTemplate: '+XXX XXX XXX XXX',
    flag: '🇵🇹',
  },
  {
    countryCode: 'PW',
    countryName: 'Палау',
    phonePrefix: '+680',
    phoneTemplate: '+XXX XXX XXXX',
    flag: '🇵🇼',
  },
  {
    countryCode: 'PY',
    countryName: 'Парагвай',
    phonePrefix: '+595',
    phoneTemplate: '+XXX XXX XXXXXX',
    flag: '🇵🇾',
  },
  {
    countryCode: 'QA',
    countryName: 'Катар',
    phonePrefix: '+974',
    phoneTemplate: '+XXX XXXX XXXX',
    flag: '🇶🇦',
  },
  {
    countryCode: 'RE',
    countryName: 'Реюньон',
    phonePrefix: '+262',
    phoneTemplate: '+XXX XXX XX XX XX',
    flag: '🇷🇪',
  },
  {
    countryCode: 'RO',
    countryName: 'Румыния',
    phonePrefix: '+40',
    phoneTemplate: '+XX XXX XXX XXX',
    flag: '🇷🇴',
  },
  {
    countryCode: 'RS',
    countryName: 'Сербия',
    phonePrefix: '+381',
    phoneTemplate: '+XXX XX XXXXXXX',
    flag: '🇷🇸',
  },
  {
    countryCode: 'RU',
    countryName: 'Россия',
    phonePrefix: '+7',
    phoneTemplate: '+X XXX XXX-XX-XX',
    flag: '🇷🇺',
  },
  {
    countryCode: 'RW',
    countryName: 'Руанда',
    phonePrefix: '+250',
    phoneTemplate: '+XXX XXX XXX XXX',
    flag: '🇷🇼',
  },
  {
    countryCode: 'SA',
    countryName: 'Саудовская Аравия',
    phonePrefix: '+966',
    phoneTemplate: '+XXX XX XXX XXXX',
    flag: '🇸🇦',
  },
  {
    countryCode: 'SB',
    countryName: 'Соломоновы о-ва',
    phonePrefix: '+677',
    phoneTemplate: '+XXX XX XXXXX',
    flag: '🇸🇧',
  },
  {
    countryCode: 'SC',
    countryName: 'Сейшельские о-ва',
    phonePrefix: '+248',
    phoneTemplate: '+XXX X XXX XXX',
    flag: '🇸🇨',
  },
  {
    countryCode: 'SD',
    countryName: 'Судан',
    phonePrefix: '+249',
    phoneTemplate: '+XXX XX XXX XXXX',
    flag: '🇸🇩',
  },
  {
    countryCode: 'SE',
    countryName: 'Швеция',
    phonePrefix: '+46',
    phoneTemplate: '+XX XX XXX XX XX',
    flag: '🇸🇪',
  },
  {
    countryCode: 'SG',
    countryName: 'Сингапур',
    phonePrefix: '+65',
    phoneTemplate: '+XX XXXX XXXX',
    flag: '🇸🇬',
  },
  {
    countryCode: 'SH',
    countryName: 'о-в Св. Елены',
    phonePrefix: '+290',
    phoneTemplate: '+XXX XXXXX',
    flag: '🇸🇭',
  },
  {
    countryCode: 'SI',
    countryName: 'Словения',
    phonePrefix: '+386',
    phoneTemplate: '+XXX XX XXX XXX',
    flag: '🇸🇮',
  },
  {
    countryCode: 'SJ',
    countryName: 'Шпицберген и Ян-Майен',
    phonePrefix: '+47',
    phoneTemplate: '+XX XX XX XX XX',
    flag: '🇸🇯',
  },
  {
    countryCode: 'SK',
    countryName: 'Словакия',
    phonePrefix: '+421',
    phoneTemplate: '+XXX XXX XXX XXX',
    flag: '🇸🇰',
  },
  {
    countryCode: 'SL',
    countryName: 'Сьерра-Леоне',
    phonePrefix: '+232',
    phoneTemplate: '+XXX XX XXXXXX',
    flag: '🇸🇱',
  },
  {
    countryCode: 'SM',
    countryName: 'Сан-Марино',
    phonePrefix: '+378',
    phoneTemplate: '+XXX XX XX XX XX',
    flag: '🇸🇲',
  },
  {
    countryCode: 'SN',
    countryName: 'Сенегал',
    phonePrefix: '+221',
    phoneTemplate: '+XXX XX XXX XX XX',
    flag: '🇸🇳',
  },
  {
    countryCode: 'SO',
    countryName: 'Сомали',
    phonePrefix: '+252',
    phoneTemplate: '+XXX X XXXXXXX',
    flag: '🇸🇴',
  },
  {
    countryCode: 'SR',
    countryName: 'Суринам',
    phonePrefix: '+597',
    phoneTemplate: '+XXX XXX-XXXX',
    flag: '🇸🇷',
  },
  {
    countryCode: 'SS',
    countryName: 'Южный Судан',
    phonePrefix: '+211',
    phoneTemplate: '+XXX XXX XXX XXX',
    flag: '🇸🇸',
  },
  {
    countryCode: 'ST',
    countryName: 'Сан-Томе и Принсипи',
    phonePrefix: '+239',
    phoneTemplate: '+XXX XXX XXXX',
    flag: '🇸🇹',
  },
  {
    countryCode: 'SV',
    countryName: 'Сальвадор',
    phonePrefix: '+503',
    phoneTemplate: '+XXX XXXX XXXX',
    flag: '🇸🇻',
  },
  {
    countryCode: 'SX',
    countryName: 'Синт-Мартен',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇸🇽',
  },
  {
    countryCode: 'SY',
    countryName: 'Сирия',
    phonePrefix: '+963',
    phoneTemplate: '+XXX XXX XXX XXX',
    flag: '🇸🇾',
  },
  {
    countryCode: 'SZ',
    countryName: 'Эсватини',
    phonePrefix: '+268',
    phoneTemplate: '+XXX XXXX XXXX',
    flag: '🇸🇿',
  },
  {
    countryCode: 'TC',
    countryName: 'Тёркс и Кайкос',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇹🇨',
  },
  {
    countryCode: 'TD',
    countryName: 'Чад',
    phonePrefix: '+235',
    phoneTemplate: '+XXX XX XX XX XX',
    flag: '🇹🇩',
  },
  {
    countryCode: 'TG',
    countryName: 'Того',
    phonePrefix: '+228',
    phoneTemplate: '+XXX XX XX XX XX',
    flag: '🇹🇬',
  },
  {
    countryCode: 'TH',
    countryName: 'Таиланд',
    phonePrefix: '+66',
    phoneTemplate: '+XX XX XXX XXXX',
    flag: '🇹🇭',
  },
  {
    countryCode: 'TJ',
    countryName: 'Таджикистан',
    phonePrefix: '+992',
    phoneTemplate: '+XXX XX XXX XXXX',
    flag: '🇹🇯',
  },
  {
    countryCode: 'TK',
    countryName: 'Токелау',
    phonePrefix: '+690',
    phoneTemplate: '+XXX XXXX',
    flag: '🇹🇰',
  },
  {
    countryCode: 'TL',
    countryName: 'Восточный Тимор',
    phonePrefix: '+670',
    phoneTemplate: '+XXX XXXX XXXX',
    flag: '🇹🇱',
  },
  {
    countryCode: 'TM',
    countryName: 'Туркменистан',
    phonePrefix: '+993',
    phoneTemplate: '+XXX XX XXXXXX',
    flag: '🇹🇲',
  },
  {
    countryCode: 'TN',
    countryName: 'Тунис',
    phonePrefix: '+216',
    phoneTemplate: '+XXX XX XXX XXX',
    flag: '🇹🇳',
  },
  {
    countryCode: 'TO',
    countryName: 'Тонга',
    phonePrefix: '+676',
    phoneTemplate: '+XXX XXX XXXX',
    flag: '🇹🇴',
  },
  {
    countryCode: 'TR',
    countryName: 'Турция',
    phonePrefix: '+90',
    phoneTemplate: '+XX XXX XXX XX XX',
    flag: '🇹🇷',
  },
  {
    countryCode: 'TT',
    countryName: 'Тринидад и Тобаго',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇹🇹',
  },
  {
    countryCode: 'TV',
    countryName: 'Тувалу',
    phonePrefix: '+688',
    phoneTemplate: '+XXX XX XXXX',
    flag: '🇹🇻',
  },
  {
    countryCode: 'TW',
    countryName: 'Тайвань',
    phonePrefix: '+886',
    phoneTemplate: '+XXX XXX XXX XXX',
    flag: '🇹🇼',
  },
  {
    countryCode: 'TZ',
    countryName: 'Танзания',
    phonePrefix: '+255',
    phoneTemplate: '+XXX XXX XXX XXX',
    flag: '🇹🇿',
  },
  {
    countryCode: 'UA',
    countryName: 'Украина',
    phonePrefix: '+380',
    phoneTemplate: '+XXX XX XXX XXXX',
    flag: '🇺🇦',
  },
  {
    countryCode: 'UG',
    countryName: 'Уганда',
    phonePrefix: '+256',
    phoneTemplate: '+XXX XXX XXXXXX',
    flag: '🇺🇬',
  },
  {
    countryCode: 'US',
    countryName: 'Соединенные Штаты',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇺🇸',
  },
  {
    countryCode: 'UY',
    countryName: 'Уругвай',
    phonePrefix: '+598',
    phoneTemplate: '+XXX XX XXX XXX',
    flag: '🇺🇾',
  },
  {
    countryCode: 'UZ',
    countryName: 'Узбекистан',
    phonePrefix: '+998',
    phoneTemplate: '+XXX XX XXX XX XX',
    flag: '🇺🇿',
  },
  {
    countryCode: 'VA',
    countryName: 'Ватикан',
    phonePrefix: '+39',
    phoneTemplate: '+XX XXX XXX XXXX',
    flag: '🇻🇦',
  },
  {
    countryCode: 'VC',
    countryName: 'Сент-Винсент и Гренадины',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇻🇨',
  },
  {
    countryCode: 'VE',
    countryName: 'Венесуэла',
    phonePrefix: '+58',
    phoneTemplate: '+XX XXX-XXXXXXX',
    flag: '🇻🇪',
  },
  {
    countryCode: 'VG',
    countryName: 'Виргинские о-ва (Великобритания)',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇻🇬',
  },
  {
    countryCode: 'VI',
    countryName: 'Виргинские о-ва (США)',
    phonePrefix: '+1',
    phoneTemplate: '+X XXX-XXX-XXXX',
    flag: '🇻🇮',
  },
  {
    countryCode: 'VN',
    countryName: 'Вьетнам',
    phonePrefix: '+84',
    phoneTemplate: '+XX XXX XXX XXX',
    flag: '🇻🇳',
  },
  {
    countryCode: 'VU',
    countryName: 'Вануату',
    phonePrefix: '+678',
    phoneTemplate: '+XXX XXX XXXX',
    flag: '🇻🇺',
  },
  {
    countryCode: 'WF',
    countryName: 'Уоллис и Футуна',
    phonePrefix: '+681',
    phoneTemplate: '+XXX XX XX XX',
    flag: '🇼🇫',
  },
  {
    countryCode: 'WS',
    countryName: 'Самоа',
    phonePrefix: '+685',
    phoneTemplate: '+XXX XX XXXXX',
    flag: '🇼🇸',
  },
  {
    countryCode: 'YE',
    countryName: 'Йемен',
    phonePrefix: '+967',
    phoneTemplate: '+XXX XXX XXX XXX',
    flag: '🇾🇪',
  },
  {
    countryCode: 'YT',
    countryName: 'Майотта',
    phonePrefix: '+262',
    phoneTemplate: '+XXX XXX XX XX XX',
    flag: '🇾🇹',
  },
  {
    countryCode: 'ZA',
    countryName: 'Южно-Африканская Республика',
    phonePrefix: '+27',
    phoneTemplate: '+XX XX XXX XXXX',
    flag: '🇿🇦',
  },
  {
    countryCode: 'ZM',
    countryName: 'Замбия',
    phonePrefix: '+260',
    phoneTemplate: '+XXX XX XXXXXXX',
    flag: '🇿🇲',
  },
  {
    countryCode: 'ZW',
    countryName: 'Зимбабве',
    phonePrefix: '+263',
    phoneTemplate: '+XXX XX XXX XXXX',
    flag: '🇿🇼',
  },
];
